module.exports = __webpack_public_path__ + "static/img/55.5dc47ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/55.png
// module id = T0xl
// module chunks = 0